import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export function ProtectedRoute({ children, role }) {
  const { session, appUser, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--color-bg)' }}>
        <p style={{ color: 'var(--color-text-muted)' }}>Loading…</p>
      </div>
    );
  }

  if (!session) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  if (!appUser) {
    return <Navigate to="/" replace />;
  }

  if (role && appUser.role !== role) {
    if (appUser.role === 'admin') return <Navigate to="/admin" replace />;
    if (appUser.role === 'member') return <Navigate to="/member" replace />;
    return <Navigate to="/" replace />;
  }

  return children;
}

export function LoginOrRedirect({ children }) {
  const { session, appUser, loading } = useAuth();

  if (loading) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', background: 'var(--color-bg)' }}>
        <p style={{ color: 'var(--color-text-muted)' }}>Loading…</p>
      </div>
    );
  }

  if (session && appUser) {
    if (appUser.role === 'admin') return <Navigate to="/admin" replace />;
    if (appUser.role === 'member') return <Navigate to="/member" replace />;
  }

  return children;
}
